import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AdvertisingPlatformInfoForm} from './advertising-platform-info-form';

export class XAdsInfoForm extends AdvertisingPlatformInfoForm {

  constructor() {
    super();
    this.formGroup = new FormGroup({
      currencyId: new FormControl('', Validators.required),
      accountId: new FormControl('', Validators.required),
      pixelToken: new FormControl('', Validators.required),
    });
  }

  static override getPlatformName(): string {
    return 'x-ads';
  }
}
